export const SEARCH_BY_BRAND_REQUEST = 'SEARCH_BY_BRAND_REQUEST';
export const SEARCH_BY_BRAND_REQUEST_SUCCESS = 'SEARCH_BY_BRAND_REQUEST_SUCCESS';
export const SEARCH_BY_BRAND_REQUEST_FAILURE = 'SEARCH_BY_BRAND_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/constants/search_by_brand.constants.js